import React from "react";
import { TextField } from "@mui/material";
import { useTableGlobalInvoicesConfig } from "./hooks";
import { useSelector } from "react-redux";
import { formatCustomDate } from "helpers/dateTools";

export const GlobalInvoicesSelectStartDate = () => {
  const { handleInputs } = useTableGlobalInvoicesConfig();
  const startDate = useSelector(({ globalInvoices }) => globalInvoices.startDate);

  return (
    <TextField
      size="small"
      label="Inicio"
      type="date"
      name="startDate"
      value={startDate}
      variant="outlined"
      InputLabelProps={{ shrink: true }}
      onChange={({ target: { name, value } }) => handleInputs(name, value)}
      inputProps={{
        max: formatCustomDate(new Date(), "-"),
      }}
      fullWidth
    />
  );
};
